import { Schema } from '@guiker/real-estate-shared'
import { TypeOf, yup } from '@guiker/shared-framework'

export const updatePropertyFinancialInfoFinancials = yup.object({
  financialInfo: yup.object({ financials: Schema.financials }),
})

export type UpdatePropertyFinancialInfoFinancials = TypeOf<typeof updatePropertyFinancialInfoFinancials>
